import { axiosBase } from 'utils';

export function aiSearchService(query) {
  const axios = axiosBase.create();
  return axios({
    method: 'GET',
    url: `/ai-search/search?query=${encodeURIComponent(query)}`,
  });
}
